export const g1 = 0x0c1013
export const g2 = 0x3f4443
export const g3 = 0x727472
export const g4 = 0xc1c4c2

// export const purple = 0x8b53b0
// export const purpleDull = 0x4d2d62

export const floor = 0x96a6c0

// export const grays = [g1, g2, g3, g4]
// export const all = [g1, g2, g3, g4, purple]

export const damage = 0x632e00

// export const green = 0x8fc93a
export const greenDull = 0x44601a
export const red = 0xfd0d15
export const redDull = 0xa20207

export const yellow = 0xffb30f

export const offwhite = 0xf2deab
export const offwhiteDull = 0xc2b289
export const offwhiteBorder = 0x6a583e

export const offblack = 0x9b5d2b
export const offblackDull = 0x7c4a22

export const green = 0x638475
export const blue = 0x547aa5

export const purple = 0xa9b3ce
export const purpleDull = 0xa9b3ce

export const background = 0x342e37 //0x70a0af

export const button = 0x6a583e
export const buttonDown = 0xc2b289
export const buttonHover = blue
